import { connect } from 'react-redux';
import { actions } from '../../../redux/modules/profile';
import Profile from './Profile';
import {resetStore} from "../../../redux/modules/login";


const ms2p = (state) => {
    return {
        ...state.profile,
    };
};

const md2p = { ...actions, resetStore };
export default connect(ms2p, md2p)(Profile);
